import { render, staticRenderFns } from "./FollowupsTable.vue?vue&type=template&id=4f84633d&"
import script from "./FollowupsTable.vue?vue&type=script&lang=js&"
export * from "./FollowupsTable.vue?vue&type=script&lang=js&"
import style0 from "./FollowupsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports